<template>
  <div class="app">
    <div class="careers careers--component">
      <CareerResults />
    </div>
  </div>
</template>

<script>

import CareerSearch from '@/components/CareerSearch.vue'
import CareerResults from '@/components/CareerResults.vue'

export default {
  name: 'DynamicCareer',
  components: {
    CareerSearch,
    CareerResults
  },
  data () {
    return {
      career: '',
    }
  },
  created () {
    this.career = window.career ? window.career : this.career
    this.$store.commit('results/setKeyword', this.career)
  }
}
</script>

<style lang="scss" scoped>
@use 'mixins' as *;
@use 'variables';

.app {
  position: relative;
}

.careers {
  display: flex;
  flex-direction: column;
  max-width: 1200px;
  margin: 0 auto;
  overflow-x: hidden;
  position: relative;
  padding-bottom: 2rem;
  box-sizing: border-box;

  @include breakpoint-md {
    flex-direction: row;
    overflow-x: unset;
  }

  &--component {
    .list-item {
      background-color: transparent;
      border-radius: 10px;
      overflow: hidden;

      &:hover, &:focus {
        background-color: variables.$color-white;
      }
    }

    .page-results,
    .pagination {
      display: none;
    }
  }

  &--min-height-100vh{
    min-height: 100vh;
  }
}
</style>
